var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-circle-outline",
    transform: "translate(-3.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M17.5,3.5a14,14,0,0,1,5.449,26.9,14,14,0,0,1-10.9-25.8A13.905,13.905,0,0,1,17.5,3.5Zm0,26.526a12.53,12.53,0,1,0-8.856-3.67A12.444,12.444,0,0,0,17.5,30.026Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M17.729,10.253a1.134,1.134,0,0,1,1.133,1.184l-.4,8.426a.737.737,0,0,1-1.472,0l-.4-8.425q0-.034,0-.067a1.134,1.134,0,0,1,1.121-1.119Z",
    transform: "translate(-0.23 -0.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M17.975,25.82a1.381,1.381,0,1,1,1.381-1.381A1.381,1.381,0,0,1,17.975,25.82Z",
    transform: "translate(-0.475 -0.589)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert_icon.ea43d4f1069e890ce839df7143fcaf4a.svg";